<template lang="html">
  <div class="cw-support is-readable-width auto-margin">
    <div class="hero is-small has-text-centered is-bottom-paddingless">
      <div class="hero-body">
        <div class="has-text-grey-medium">
          <icon name="profile" scale="4" label="set"></icon>
        </div>
        <h1 class="title is-size-4">App Support</h1>
        <div class="columns centerit">
          <div class="column is-two-thirds">
            <h3 class="subtitle is-size-5 is-marginless">
              Receive support regarding issues with the website or mobile app.
            </h3>
            <p class="is-size-6 has-text-grey-light"></p>
          </div>
        </div>
      </div>
    </div>
    <section class="section">
      <form class="form">
        <label class="label font-light">Contact Information</label>
        <label class="label font-light has-text-grey-medium">
          If you have an account, please use your email address associated with
          that account.
        </label>
        <div class="field">
          <div class="control has-icons-left">
            <span class="icon is-left">
              <i class="las la-2x la-envelope"></i>
            </span>
            <input
              class="input is-underlined is-medium"
              :class="{ 'is-danger': $v.email.$error }"
              type="email"
              placeholder="Email Address"
              v-model="email"
              @input="$v.email.$touch()"
              @focus="$v.email.$touch()"
            />
            <p class="help" v-if="$v.email.$dirty && !$v.email.required">
              This field is required.
            </p>
            <p class="help" v-if="!$v.email.email">
              Not a valid email address.
            </p>
          </div>
        </div>

        <label
          class="label font-light is-padded-large is-bottom-paddingless is-horizontal-paddingless"
          >Details</label
        >
        <div
          class="field is-grouped is-padded-large is-horizontal-paddingless is-top-paddingless"
        >
          <div class="control">
            <cw-dropdown
              :isActive.sync="platformDropdownActive"
              class="selection-dropdown anchored-bottom"
            >
              <div slot="trigger">
                <p class="button is-black is-outlined">
                  {{ platform || 'Platform' }}
                </p>
              </div>
              <ul v-for="p in ['Website', 'Mobile App']" :key="p">
                <li class="dropdown-item" @click="selectPlatform(p)">
                  {{ p }}
                </li>
              </ul>
            </cw-dropdown>
          </div>
          <div class="control">
            <cw-dropdown
              :isActive.sync="deviceDropdownActive"
              class="selection-dropdown anchored-bottom"
            >
              <div slot="trigger">
                <p class="button is-black is-outlined">
                  {{ device || 'Device' }}
                </p>
              </div>
              <ul v-for="d in ['Android', 'iPhone or iPad', 'Other']" :key="d">
                <li class="dropdown-item" @click="selectDevice(d)">{{ d }}</li>
              </ul>
            </cw-dropdown>
          </div>
        </div>
        <label class="label font-light has-text-grey-medium">
          Please describe any issues you are experiencing as clearly as
          possible.
        </label>
        <div class="field">
          <div class="control">
            <textarea
              class="textarea is-medium"
              placeholder="Details"
              rows="6"
              v-model="details"
              :class="{
                'is-danger': $v.details.$dirty && !$v.details.required,
              }"
              @input="$v.details.$touch()"
              @focus="$v.details.$touch()"
            >
            </textarea>
            <p class="help" v-if="$v.details.$dirty && !$v.details.required">
              This field is required.
            </p>
          </div>
        </div>
        <div class="field is-grouped is-grouped-right">
          <div class="control">
            <button
              class="button is-medium is-black is-rounded"
              type="button"
              name="button"
              @click="cancel"
            >
              Cancel
            </button>
          </div>
          <div class="control">
            <button
              class="button is-medium is-primary is-rounded"
              type="button"
              name="button"
              @click="submit"
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
let apiHost = process.env.VUE_APP_API_HOST;

import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'cw-support',
  // share common functionality with component mixins
  mixins: [validationMixin],
  props: {},
  // variables
  data() {
    return {
      email: '',
      platform: '',
      device: '',
      details: '',

      platformDropdownActive: false,
      deviceDropdownActive: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
    details: {
      required,
    },
  },
  computed: {},
  components: {},
  methods: {
    selectPlatform(p) {
      this.platform = p;
      this.platformDropdownActive = false;
    },
    selectDevice(d) {
      this.device = d;
      this.deviceDropdownActive = false;
    },
    async submit() {
      // Validate Client side
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$modal.show('alert', {
          title: 'Insufficient Info',
          message:
            'Some of the fields are invalid. Please check that you have entered the required information.',
          type: 'warning',
        });
        return;
      }
      this.$modal.show('wifi-loader', { message: 'Processing...' });

      try {
        await axios.post(
          `${apiHost}/auth/support`,
          {
            email: this.email,
            device: this.device,
            platform: this.platform,
            details: this.details,
          },
          {
            headers: {
              Authorization: this.$store.state.user.token,
            },
          }
        );

        this.$modal.hide('wifi-loader');
        this.$modal.show('alert', {
          title: 'Success',
          message:
            'Your feedback has been sent. You will receive a response soon.',
        });
        this.$router.push('/');
      } catch (err) {
        this.$modal.hide('wifi-loader');
        let res = err.response;
        if (res && res.data) {
          this.$modal.show('alert', {
            title: res.data.title,
            message: res.data.message,
            type: 'warning',
          });
        }
      }
    },
    cancel() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.email = this.$store.state.user.info.email;
  },
};
</script>

<style lang="stylus" scoped></style>
